import { PhoneArrowDownLeftIcon } from '@heroicons/react/24/solid';
import CallMenu from 'src/components/molecules/calls/call-menu/call-menu';
import Button from 'src/modules/shared/components/atoms/buttons/button';

interface CallButtonProps {
  startCall: () => void;
  disabled?: boolean;
  callWithoutInternetChoose: boolean;
  callingWithoutInternet: boolean;
  updateSetting: (value: boolean) => void;
}

const CallButton = ({
  startCall,
  disabled = false,
  callWithoutInternetChoose,
  callingWithoutInternet,
  updateSetting,
}: CallButtonProps) => {
  const buttonClasses = `flex-1 rounded-l-lg w-full`;

  if (callWithoutInternetChoose) {
    return (
      <div className={'flex flex-row w-full'}>
        <Button
          size="md"
          disabled={disabled}
          onClick={() => startCall()}
          variant="call"
          appearance="filled"
          className={buttonClasses}
        >
          <div className="flex items-center justify-center space-x-2">
            <span className="text-sm">Llamar</span>
            {callingWithoutInternet ? (
              <PhoneArrowDownLeftIcon className="h-4 w-4" />
            ) : null}
          </div>
        </Button>
        <CallMenu
          callingWithoutInternet={callingWithoutInternet}
          updateSetting={updateSetting}
        />
      </div>
    );
  }

  return (
    <Button
      size="md"
      disabled={disabled}
      onClick={() => startCall()}
      variant="call"
      appearance="filled"
      className={buttonClasses}
    >
      <div className="flex items-center justify-center space-x-2">
        <span className="text-sm">Llamar</span>
      </div>
    </Button>
  );
};

export default CallButton;
